import { Avatar } from '@ads/components-react';
import { useTranslation } from 'react-i18next';
import { AudioPlayer } from './AudioPlayer';

export interface StudentAnswerProps {
  /** Nome do aluno que respondeu */
  readonly student: string | null | undefined;
  /** Conteúdo da resposta — texto ou URL do áudio */
  readonly value: string | null | undefined;
  /** Indica que a resposta é um áudio gravado e deve usar o player */
  readonly isAudio: boolean;
}

/** Identificação do aluno e conteúdo da resposta enviada. */
export function StudentAnswer({ student, value, isAudio }: StudentAnswerProps) {
  const { t } = useTranslation('examCorrection');

  return (
    <>
      <div className="flex flex-col gap-nano">
        <span className="text-ctx-content-placeholder ts-caption-xxs">
          {t('modal.fields.student')}
        </span>
        <div className="flex items-center gap-nano">
          <Avatar size="md" fallback={(student ?? 'A').charAt(0).toUpperCase()} />
          <span className="text-ctx-content-title ts-subtitle-xs">
            {student ?? t('modal.unknownStudent')}
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-nano">
        <span className="text-ctx-content-placeholder ts-caption-xxs">
          {t('modal.fields.answer')}
        </span>
        {isAudio && value ? (
          <AudioPlayer src={value} />
        ) : (
          <div className="rounded-sm border-thin border-ctx-layout-border bg-ctx-layout-body p-xs">
            <p className="text-ctx-content-base ts-paragraph-xs">{value ?? t('modal.noContent')}</p>
          </div>
        )}
      </div>
    </>
  );
}
